import Axes, { AxisPropTypes } from './axes';

export { Axes, AxisPropTypes };
